var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.authUser == null && _vm.$route.name !== 'Login')?_c('div',[_c('div',{staticClass:"d-flex justify-content-center align-items-center",staticStyle:{"height":"100vh"}},[_c('fingerprint-spinner',{attrs:{"animation-duration":1500,"size":128,"color":"#ff1d5e"}})],1)]):[_c('router-view'),_c('SharedAccountsModal')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }